/**
 * Game action enum.
 */
export enum GameActionEnum {
  PushOut, PassBack, ConcedeFrame,
}
